import { initializeApp, getApps, getApp, deleteApp } from "firebase/app";
import {
    getAuth,
    signInWithEmailAndPassword,
    signOut as fbSignOut,
    onAuthStateChanged,
} from "firebase/auth";
import {
    getFirestore,
    doc,
    getDoc,
    setDoc,
    collection,
    getDocs,
} from "firebase/firestore";

const APP_NAME = "ka-academy";

// Built-in default config (so deployed builds always work, even without .env)
const DEFAULT_FIREBASE_CONFIG = {
    apiKey: "AIzaSyAROTluWrHFVD1bqJLXNOEKNiW9y3k0xQQ",
    authDomain: "kaacademy-94675.firebaseapp.com",
    projectId: "kaacademy-94675",
    storageBucket: "kaacademy-94675.firebasestorage.app",
    messagingSenderId: "551310032175",
    appId: "1:551310032175:web:d79795ca4e150885ef35da",
    measurementId: "G-S94C3EXPF4",
};

function getEnvFirebaseConfig() {
    const cfg = {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY || DEFAULT_FIREBASE_CONFIG.apiKey,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || DEFAULT_FIREBASE_CONFIG.authDomain,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || DEFAULT_FIREBASE_CONFIG.projectId,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || DEFAULT_FIREBASE_CONFIG.storageBucket,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || DEFAULT_FIREBASE_CONFIG.messagingSenderId,
        appId: process.env.REACT_APP_FIREBASE_APP_ID || DEFAULT_FIREBASE_CONFIG.appId,
        measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || DEFAULT_FIREBASE_CONFIG.measurementId,
    };
    if (!cfg.apiKey || !cfg.projectId) return null;
    return cfg;
}

export function getFirebaseConfig() {
    try {
        const raw = localStorage.getItem("ka_firebase_config");
        if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed.apiKey && parsed.projectId) return parsed;
        }
    } catch {
        /* fall through to env/defaults */
    }
    return getEnvFirebaseConfig();
}

export function saveFirebaseConfig(cfg) {
    localStorage.setItem("ka_firebase_config", JSON.stringify(cfg));
    // Force re-init next call
    try {
        const existing = getApps().find((a) => a.name === APP_NAME);
        if (existing) deleteApp(existing);
    } catch {
        /* noop */
    }
}

export function clearFirebaseConfig() {
    localStorage.removeItem("ka_firebase_config");
    try {
        const existing = getApps().find((a) => a.name === APP_NAME);
        if (existing) deleteApp(existing);
    } catch {
        /* noop */
    }
}

export function firebaseReady() {
    return !!getFirebaseConfig();
}

export function getFb() {
    const cfg = getFirebaseConfig();
    if (!cfg) return null;
    let app;
    try {
        app =
            getApps().find((a) => a.name === APP_NAME) ||
            initializeApp(cfg, APP_NAME);
    } catch (e) {
        console.error("Firebase init failed", e);
        return null;
    }
    return {
        app,
        auth: getAuth(app),
        db: getFirestore(app),
    };
}

export async function fbLogin(email, password) {
    const fb = getFb();
    if (!fb) throw new Error("Firebase konfiqurasiyası tapılmadı");
    const cred = await signInWithEmailAndPassword(fb.auth, email, password);
    return cred.user;
}

export async function fbLogout() {
    const fb = getFb();
    if (!fb) return;
    await fbSignOut(fb.auth);
}

export function fbOnAuth(cb) {
    const fb = getFb();
    if (!fb) {
        cb(null);
        return () => {};
    }
    return onAuthStateChanged(fb.auth, cb);
}

export async function fbReadDoc(path) {
    const fb = getFb();
    if (!fb) return null;
    const [col, id] = path.split("/");
    const snap = await getDoc(doc(fb.db, col, id));
    return snap.exists() ? snap.data() : null;
}

export async function fbWriteDoc(path, data) {
    const fb = getFb();
    if (!fb) throw new Error("Firebase konfiqurasiyası yoxdur");
    const [col, id] = path.split("/");
    await setDoc(doc(fb.db, col, id), data, { merge: true });
}

export async function fbReadAll(colName) {
    const fb = getFb();
    if (!fb) return [];
    const snap = await getDocs(collection(fb.db, colName));
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}
